// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AHaSr","menuIcon":"Navbar_menuIcon__kHbhh","navLinks":"Navbar_navLinks__pxUEg","showMenu":"Navbar_showMenu__VMkls"};